import {OrderGridView} from './OrderGridView/OrderGridView';
import {OrdersListView} from './OrdersListView/OrdersListView';
import {ViewMode} from '../Components/ViewSelector'
import { IEntityData } from '@core/Models/i-entity';
import { ICrmCellInputEditors, IMousePosition } from '@pluginShared/core-ui-api';
import { useState, MutableRefObject, useRef } from 'react';
import { OrderGridViewEditors } from './OrderGridView/OrderGridViewEditors/OrderGridViewEditors';
import { IOrderContextMenu, OrderContextMenu } from './OrderContextMenu/OrderContextMenu';
import { IEventSouringQueryViewState } from '@core/EventSourcing/Implementation/LiveQueryView';
import { ICrmField } from '@core/Models/autogenerated/tenantConfig.models';

export interface IEntitiesViewProps {
    viewMode: ViewMode;
    fields: ICrmField[];
    tableId: string;
    entityIds: string[];
    onEditEntity: (entityId: string) => void;
    itemsPerPage: number;
    ResetCursor: () => void;
    MoveCursor: (offset: number) => void;
    cursorAtStart: boolean;
    cursorAtEnd: boolean;
    currentOffset: number;
    queryStatus: IEventSouringQueryViewState;

    selectedRows?: string[] | "all";
    onChangeSelectedRows?: (entityIds: string[] | "all") => void;

    simpleFilters: {[columnId: string]: any};
    onChangedSimpleQuery: (columnId: string, query: any) => void;
    onResetSimpleQuery: (columnId: string) => void;
}

export function EntitiesView(props: IEntitiesViewProps) {
    const [selectedEntityId, setSelectedEntityId] = useState<string | undefined>(undefined);

    const cellEditorsRef = useRef<ICrmCellInputEditors>({
        showEditor: (tableId: string, entityId: string, entityData: IEntityData, field: ICrmField, position: IMousePosition, targetRef?: React.MutableRefObject<any>) => {},
        hideEditor: () => {},
    });

    const contextMenuRef = useRef<IOrderContextMenu>({
        onContextMenu: (e: MouseEvent, ref: MutableRefObject<any>, tableId:string, entityId: string, entityData: IEntityData, field?: ICrmField) => {},
    });

    const onEditEntity = (entityId: string) => {
        setSelectedEntityId(entityId);
        props.onEditEntity(entityId);
    }
    
    return (<>
        <>{props.viewMode === ViewMode.List
            ? <OrdersListView
                tableId={props.tableId}
                entityIds={props.entityIds}
                fields={props.fields}
                numRowsPerPage={props.itemsPerPage}
                contextMenuRef={contextMenuRef}
                selectedEntityId={selectedEntityId}
                onEditEntity={onEditEntity}/>
            : <OrderGridView
                tableId={props.tableId}
                entityIds={props.entityIds}
                fields={props.fields}
                numRowsPerPage={props.itemsPerPage}
                ResetCursor={props.ResetCursor}
                MoveCursor={props.MoveCursor}
                cursorAtStart={props.cursorAtStart}
                cursorAtEnd={props.cursorAtEnd}
                currentOffset={props.currentOffset}
                totalRecords={props.queryStatus.resultCount}
                cellEditorsRef={cellEditorsRef}
                contextMenuRef={contextMenuRef}
                selectedEntityId={selectedEntityId}
                onRowClick={setSelectedEntityId}
                simpleFilters={props.simpleFilters}
                onChangedSimpleQuery={props.onChangedSimpleQuery}
                onResetSimpleQuery={props.onResetSimpleQuery}
                selectedRows={props.selectedRows}
                onChangeSelectedRows={props.onChangeSelectedRows}/>
        }</>
        <OrderGridViewEditors cellEditorsRef={cellEditorsRef}/>
        <OrderContextMenu
            contextMenuRef={contextMenuRef}
            setSelectedEntityId={setSelectedEntityId}
            cellEditorsRef={cellEditorsRef}
            onEditEntity={onEditEntity}
            viewMode={props.viewMode}
            />
    </>);
}
